import { useMemo } from 'react';
import { ArithmeticSymbol } from './ArithmeticSymbol';

export const ArithmeticFormula = ({ filterType, hasScopes }) => {
  const hasSelectedValue = useMemo(() => {
    return (
      filterType?.conditions?.filter(
        condition => condition?.value?.[condition?.inputType] || condition.type === 'group'
      )?.length > 0
    );
  }, [JSON.stringify(filterType?.conditions)]);

  if (!hasSelectedValue) return <></>;

  return (
    <>
      {hasScopes && '('}

      {filterType?.conditions?.map(condition => {
        if (condition.type === 'group')
          return <ArithmeticFormula key={condition.id} filterType={condition} hasScopes={true} />;

        return (
          <ArithmeticSymbol
            key={condition.id}
            value={condition?.value?.[condition.inputType]}
            type={condition.actionItem}
          />
        );
      })}

      {hasScopes && ')'}
    </>
  );
};
